import { combineReducers } from "redux";
// import { createNavigationReducer } from 'react-navigation-redux-helpers'
import { routerReducer } from "react-router-redux";
import starter from "./starter";
import question from "./question";
import answer from "./answer";
import user from "./user";

export default combineReducers({
  routerReducer,
  starter,
  question,
  answer,
  user
});



// WEBPACK FOOTER //
// ./src/reducers/index.js